import Field from '@/components/ui/Field';
import SelectField from '@/components/ui/SelectField';

export default function StepCliente({ quote, setQuote }) {
  const u = (field, value) =>
    setQuote((q) => ({ ...q, cliente: { ...q.cliente, [field]: value } }));

  return (
    <div>
      <h2 className="text-xl font-semibold text-white mb-1">Datos del cliente</h2>
      <p className="text-sm text-neutral-500 mb-6">
        Información que aparecerá en la propuesta y contrato
      </p>
      <div className="grid grid-cols-2 gap-4">
        <Field
          label="Nombre completo *"
          value={quote.cliente.nombre}
          onChange={(v) => u('nombre', v)}
          placeholder="María Hernández"
        />
        <Field
          label="Puesto"
          value={quote.cliente.puesto}
          onChange={(v) => u('puesto', v)}
          placeholder="Directora de Marketing"
        />
        <Field
          label="Empresa *"
          value={quote.cliente.empresa}
          onChange={(v) => u('empresa', v)}
          placeholder="Imobilem Desarrollos"
        />
        <Field
          label="RFC"
          value={quote.cliente.rfc}
          onChange={(v) => u('rfc', v)}
          placeholder="XAXX010101000"
        />
        <Field
          label="Email *"
          value={quote.cliente.email}
          onChange={(v) => u('email', v)}
          placeholder="maria@imobilem.com"
          type="email"
        />
        <Field
          label="Teléfono"
          value={quote.cliente.telefono}
          onChange={(v) => u('telefono', v)}
          placeholder="81 1234 5678"
        />
        <Field
          label="Ciudad"
          value={quote.cliente.ciudad}
          onChange={(v) => u('ciudad', v)}
          placeholder="Monterrey"
        />
        <Field
          label="Estado"
          value={quote.cliente.estado}
          onChange={(v) => u('estado', v)}
          placeholder="Nuevo León"
        />
        <SelectField
          label="Segmento"
          value={quote.cliente.segmento}
          onChange={(v) => u('segmento', v)}
          options={[
            { v: 'desarrollador', l: 'Desarrollador inmobiliario' },
            { v: 'broker', l: 'Broker / Comercializadora' },
            { v: 'particular', l: 'Particular' },
            { v: 'agencia', l: 'Agencia / Productora' },
            { v: 'corporativo', l: 'Corporativo' },
            { v: 'otro', l: 'Otro' },
          ]}
        />
        <Field
          label="¿Cómo nos conoció?"
          value={quote.cliente.comoNosConocio}
          onChange={(v) => u('comoNosConocio', v)}
          placeholder="PropTech LATAM, referido..."
        />
      </div>
    </div>
  );
}
